import { render, staticRenderFns } from "./EducationalQualificationRecordDetails.vue?vue&type=template&id=69add924"
import script from "./EducationalQualificationRecordDetails.vue?vue&type=script&lang=ts"
export * from "./EducationalQualificationRecordDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports